export enum PromotionType {
    BASIC = 'Basic Discount',
    BRAND = 'Brand Discount',
    FREEITEM = 'Free Item',
    FREEITEM_BRAND = 'Brand Free Item',
    BRAND_EXTERNAL = 'Brand External Offer',
    INFORMATION = 'Offer Information',
    PRODUCT_DISCOUNT = 'Product Discount'
}
